@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Begin Preparation"
                  acceptLabel="OK"
                  [excludeModalStyling]="true"
                  (save)="save()"
                  (cancel)="cancel()">
    @if (isInitialized) {
        <form #addReturnForm="ngForm">
            <div class="mb-3">
                <small class="ws-flex-none">
                    <span>Select a prior return to use as the basis for calculations such as additions and disposals.</span>
                </small>
            </div>
            <div class="mb-3">
                <label for="priorReturn">Prior Return</label><br>
                <select id="priorReturn" name="priorReturn" class="form-select form-select-sm" [(ngModel)]="priorFiling" (change)="priorReturnChanged()">
                    <option [ngValue]="null">None</option>
                    @for (pf of priorFilings; track pf; let i = $index) {
                        <option [ngValue]="pf">
                            {{ pf.filingDescription + (i === 0 ? ' (Default)' : '') }}
                        </option>
                    }
                </select>
            </div>
            <div class="mb-3">
                <label class="ws-flex-none ws-font-weight-normal" for="isAmendment">
                    <input type="checkbox" id="isAmendment" name="isAmendment" [(ngModel)]="isAmendment" [disabled]="!priorReturnSelected">
                    Amending Prior Return
                </label>
            </div>
        </form>
    }
</ws-modal-wrapper>
